import { searchParams } from '@humanspace/utils/api';

const isLocal = process.env.REACT_APP_ENVIRONMENT === 'local';

const makeRequest = async ({ path, method, body, json }) => {
  const userId = window.localStorage.getItem('userId');
  const userToken = window.localStorage.getItem('userToken');

  // Use relative URL for production, or REACT_APP_API_URL if set (for local dev)
  const apiBase = process.env.REACT_APP_API_URL || '/api';
  const url = `${apiBase}${path}`;

  let requestBody;
  let contentType;

  if (json) {
    requestBody = body ? JSON.stringify(body) : undefined;
    contentType = 'application/json';
  } else {
    requestBody = body ? searchParams({ ...body, ...(userId && { userId }) }) : undefined;
    contentType = 'application/x-www-form-urlencoded';
  }

  const response = await fetch(url, {
    method: method || 'GET',
    body: requestBody,
    headers: {
      ...(userToken && { Authorization: `Bearer ${userToken}` }),
      'Content-Type': contentType,
    },
  });

  if (response.status === 204) return null;

  const text = await response.text();
  try {
    const parsed = JSON.parse(text);
    // For non-2xx responses, ensure the error is detectable
    if (!response.ok && !parsed.code && !parsed.error) {
      parsed._httpStatus = response.status;
      parsed._httpOk = false;
    }
    return parsed;
  } catch (e) {
    console.error('API response is not valid JSON:', response.status, text.substring(0, 200));
    return { code: response.status, error: { message: 'Server returned an invalid response' } };
  }
};

export default makeRequest;
